import { useEffect } from "react"
import { useNavigate } from "react-router-dom";
import { isUserLoggedIn } from "../utils/utils";

export default function WithAuth({children}) {
    const navigate = useNavigate();

    useEffect(() => {
        if (!isUserLoggedIn()) {
            navigate('/');
        }
    },[]);

    return <>{children}</>
}